import { createContext, useContext, useEffect, useState } from "react";
import { api, setToken, clearToken, getToken } from "../lib/api";

const AuthCtx = createContext(null);
export const useAuth = () => useContext(AuthCtx);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(undefined); // undefined = loading, null = not auth

  useEffect(() => {
    if (!getToken()) { setUser(null); return; }
    api.get("/auth/me").then((r) => setUser(r.data)).catch(() => { clearToken(); setUser(null); });
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    setToken(data.token);
    setUser(data.user);
    return data.user;
  };

  const register = async (name, email, password, inviteToken = "") => {
    const { data } = await api.post("/auth/register", { name, email, password, invite_token: inviteToken });
    setToken(data.token);
    setUser(data.user);
    return data.user;
  };

  const changePassword = (current_password, new_password) =>
    api.post("/auth/change-password", { current_password, new_password });

  const logout = () => { clearToken(); setUser(null); };

  const refreshMe = async () => {
    const r = await api.get("/auth/me");
    setUser(r.data);
    return r.data;
  };

  return (
    <AuthCtx.Provider value={{ user, login, register, logout, refreshMe, changePassword }}>
      {children}
    </AuthCtx.Provider>
  );
}
